import React from "react";
import DataTable from "../../../components/DataTable";

export default function SkeyepredictProjectsTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
}) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "15%",
      sorter: (a, b) =>
        (a.id || "").toString().localeCompare((b.id || "").toString()),
    },
    {
      title: "User",
      dataIndex: "username",
      key: "username",
      width: "20%",
      sorter: (a, b) => (a.username || "").localeCompare(b.username || ""),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "25%",
      sorter: (a, b) => (a.createdAt || "").localeCompare(b.createdAt || ""),
    },
    {
      title: "Project Path",
      dataIndex: "projectPath",
      key: "projectPath",
      width: "40%",
      sorter: (a, b) =>
        (a.projectPath || "").localeCompare(b.projectPath || ""),
    },
  ];

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
